<template>
  <img alt="Tunstall Software LLC Logo" style="align-items: start;" src="./assets/images/NewlogoII.png">
  <TunstallSoftware msg="Hello World"/>
  <aButton msg="Click Me Please"></aButton>

</template>

<script>
import TunstallSoftware from './components/TunsoftMain.vue'
import aButton from './components/TunsoftButton.vue'

export default {
  name: 'App',
  components: {
    TunstallSoftware, aButton
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100vh;
  width: 100vw;
  /*margin-top: 60px;*/

}

body
{
  display: block; 
  margin: 0px; 
  background-image: url(../src/assets/images/BaltimoreHarborView.jpg); 
  background-size: cover; 
  background-repeat: no-repeat; 
  background-position: center center; 

}
</style>
